import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { ISponsor } from "../shared/models/sponsor.model";
import { Utilities } from "./utilities";

@Injectable()
export class SponsorData {

  constructor(
    private afDb: AngularFireDatabase,
    private utilities: Utilities
  ) { }

  public getSponsors(clientId: string, eventId: string): Observable<ISponsor[]> {
    let reference = `Clients/${clientId}/Interactivity/Sponsor`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Sponsor`;
    }
    return this.afDb.list<ISponsor>(reference).
      valueChanges();
  }

  public getSponsorById(clientId: string, sponsorId: string, eventId: string): Observable<ISponsor> {
    let reference = `Clients/${clientId}/Interactivity/Sponsor/${sponsorId}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Sponsor/${sponsorId}`;
    }
    return this.afDb.object<ISponsor>(reference).
      valueChanges();
  }

  public createOrUpdateSponsor(clientId: string, sponsor: ISponsor, eventId: string) {
    if (!sponsor.id) {
      sponsor.created_at = new Date().getTime();
      sponsor.id = this.afDb.createPushId();
    } else {
      sponsor.update_at = new Date().getTime();
    }

    let reference = `Clients/${clientId}/Interactivity/Sponsor/${sponsor.id}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Sponsor/${sponsor.id}`;
    }

    return new Promise((res, rej) => {
      this.afDb.database
        .ref(reference)
        .update(sponsor)
        .then(() => {
          return res();
        })
        .catch((e) => {
          return rej(e);
        });
    });
  }
}
 // end file



// WEBPACK FOOTER //
// ./src/providers/sponsor.ts